/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Topics_DiscussedInputs */



/**
* | output |
* | --- |
* | "Discussed" |
*
* @param {Meeting_Topics_DiscussedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_topics_discussed = /** @type {((inputs?: Meeting_Topics_DiscussedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Topics_DiscussedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Besproken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abordé")
	return /** @type {LocalizedString} */ ("Discussed")
});